import React from 'react';
import { Prev, Next } from './Arrow';
import { usePaginationStyles } from './styles';

export default function Pagination() {
  const styles = usePaginationStyles();

  return (
    <div className={styles.pagination}>
      <Prev />
      <Next />
    </div>
  );
}
